import { data } from '../../svg/Database/data';
import { makeIcon } from '../makeIcon';

export const Database = makeIcon(data, 'database', 'Database');

export default Database;
